/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// 监听产品类型切换，更新 PayPal 分期支付金额
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // 获取新的 variant 详情
  
  // 查找 PayPal 分期支付元素
  var paypalMessageElement = document.getElementById('paypal-installment-message');
  
  if (paypalMessageElement && variant && variant.price) {
    // 计算新价格（将分转换为元）
    var newAmount = variant.price / 100.0;
    
    // 保存原始属性
    var placement = paypalMessageElement.getAttribute('data-pp-placement') || 'product';
    var buyerCountry = paypalMessageElement.getAttribute('data-pp-buyerCountry') || 'US';
    var style = paypalMessageElement.getAttribute('style') || 'margin-top: 20px;';
    
    // 获取父元素和下一个兄弟元素（用于保持位置）
    var parentElement = paypalMessageElement.parentElement;
    var nextSibling = paypalMessageElement.nextSibling;
    
    if (parentElement) {
      // 先清空旧元素内容，避免显示旧金额
      paypalMessageElement.innerHTML = '';
      
      // 创建新的 PayPal 消息元素
      var newPaypalElement = document.createElement('div');
      newPaypalElement.id = 'paypal-installment-message';
      newPaypalElement.setAttribute('style', style);
      newPaypalElement.setAttribute('data-pp-message', '');
      newPaypalElement.setAttribute('data-pp-placement', placement);
      newPaypalElement.setAttribute('data-pp-amount', newAmount.toString());
      newPaypalElement.setAttribute('data-pp-buyerCountry', buyerCountry);
      
      // 移除旧元素
      if (paypalMessageElement.parentElement) {
        paypalMessageElement.parentElement.removeChild(paypalMessageElement);
      }
      
      // 插入新元素到原位置
      if (nextSibling && nextSibling.parentElement) {
        nextSibling.parentElement.insertBefore(newPaypalElement, nextSibling);
      } else if (parentElement) {
        parentElement.appendChild(newPaypalElement);
      }
      
      // PayPal Messages SDK 使用 MutationObserver 自动检测新的 data-pp-message 元素
      // 为了确保 SDK 能够检测到新元素，我们使用 requestAnimationFrame 确保 DOM 更新完成
      requestAnimationFrame(function() {
        // 强制触发一个属性变化，帮助 PayPal SDK 的 MutationObserver 检测到新元素
        // 这是一个技巧，通过临时改变属性值再改回来，触发 MutationObserver
        newPaypalElement.setAttribute('data-pp-amount', (newAmount + 0.0001).toString());
        setTimeout(function() {
          newPaypalElement.setAttribute('data-pp-amount', newAmount.toString());
        }, 50);
      });
    }
  }
});
